var _g, _path, _g2, _path2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFintrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 45.945,
    viewBox: "0 0 155 45.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M307.416,388.178V368.945h-3.542v-4.423h3.542c0-5.771,3.343-8.656,10.135-8.656v5.05c-3.2,0-3.93.865-3.93,3.606h4.074v4.423H313.62v19.233Z",
    transform: "translate(-303.874 -355.866)",
    fill: "#ed4c14"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M323.357,364.522h6.3v23.656h-6.3Zm0-8.656h6.3v5.819h-6.3Z",
    transform: "translate(-308.138 -355.866)",
    fill: "#fe9d2b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M350.108,390.515V376.187c0-3.654-1.068-4.665-4.074-4.665-3.3,0-4.9,1.829-4.9,5.435v13.559h-6.3V366.86h6.013v3.461c1.455-2.645,3.878-4.087,7.709-4.087,4.56,0,7.906,2.74,7.906,7.886v16.4Z",
    transform: "translate(-313.61 -358.203)",
    fill: "#fe9d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M379.259,373.256h5.868v6.734c0,5-2.909,9.471-9.65,9.471-6.984,0-9.747-4.424-9.747-9.519V358.784h6.207v6.4h13.19V369.6h-13.19v9.714c0,2.98,1.066,4.71,3.635,4.71,2.522,0,3.686-1.682,3.686-4.615Z",
    transform: "translate(-320.372 -356.524)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M393.462,390.515V366.86h5.916v2.835c2.083-3.172,4.509-3.461,7.08-3.461h.824v6.395a10.7,10.7,0,0,0-1.745-.145c-3.881,0-5.771,1.924-5.771,5.723v12.308Z",
    transform: "translate(-326.441 -358.203)",
    fill: "#8abb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M426.21,378.927c-.628.625-1.744.962-4.071,1.393-3.589.675-4.752,1.683-4.752,3.7,0,1.78,1.065,2.645,3.054,2.645a5.465,5.465,0,0,0,5.721-5.145Zm.438,11.588a9.177,9.177,0,0,1-.389-2.115,9.663,9.663,0,0,1-7.223,2.74c-5.432,0-7.954-2.644-7.954-6.492,0-6.827,4.606-7.6,10.958-8.462,3.154-.432,4.026-1.058,4.026-2.692,0-1.539-1.552-2.451-4.026-2.451-2.857,0-4.024,1.394-4.314,3.509h-5.867c.1-4.9,2.814-8.319,10.474-8.319,7.564,0,10.182,3.365,10.182,9.328v14.953Z",
    transform: "translate(-330.297 -358.203)",
    fill: "#8abb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M458.227,376.927c0-5.145-1.8-7.693-5.284-7.693-3.686,0-5.431,2.451-5.431,7.308,0,4.231,2.228,7.165,5.381,7.165,3.008,0,5.334-2.789,5.334-6.78m-.1,11.251-.047-2.884a7.29,7.29,0,0,1-6.644,3.509c-6.013,0-10.328-4.712-10.328-12.695,0-7.163,3.636-12.212,9.8-12.212a8.238,8.238,0,0,1,7.078,3.7V355.866h6.207v32.312Z",
    transform: "translate(-336.868 -355.866)",
    fill: "#8abb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M489.427,376.379c-.1-3.509-2.425-5.192-4.9-5.192-2.522,0-4.606,1.922-4.849,5.192Zm-9.94,3.942c.192,3.56,2.229,5.866,5.333,5.866,2.037,0,3.832-1.008,4.267-2.645h6.5c-1.455,4.858-5.381,7.6-10.475,7.6-7.952,0-11.929-4.327-11.929-12.885,0-7.309,4.219-12.022,11.542-12.022s11.2,4.712,11.2,14.087Z",
    transform: "translate(-343.887 -358.203)",
    fill: "#8abb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M313.538,410.005l1.034.259a3.45,3.45,0,0,1-1.17,1.926,3.241,3.241,0,0,1-2.065.663,3.736,3.736,0,0,1-2.054-.51,3.2,3.2,0,0,1-1.2-1.477,5.24,5.24,0,0,1-.413-2.077,4.522,4.522,0,0,1,.467-2.111,3.181,3.181,0,0,1,1.326-1.369,3.91,3.91,0,0,1,1.9-.468,3.224,3.224,0,0,1,1.972.592,3.073,3.073,0,0,1,1.114,1.665l-1.018.237a2.394,2.394,0,0,0-.789-1.231,2.114,2.114,0,0,0-1.3-.386,2.538,2.538,0,0,0-1.505.428,2.261,2.261,0,0,0-.85,1.149,4.6,4.6,0,0,0-.245,1.488,4.687,4.687,0,0,0,.291,1.725,2.149,2.149,0,0,0,.9,1.1,2.55,2.55,0,0,0,1.327.365,2.235,2.235,0,0,0,1.471-.5,2.536,2.536,0,0,0,.816-1.474",
    transform: "translate(-307.664 -366.908)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M320.7,412.61h1.007a2.79,2.79,0,0,0,1.3-.22.75.75,0,0,0,.384-.7.806.806,0,0,0-.327-.687,2.2,2.2,0,0,0-1.229-.243H320.7Zm-2.532-4.841H320.7v2.193h1.22a2.885,2.885,0,0,1,1.882.5,1.55,1.55,0,0,1,.586,1.224,1.517,1.517,0,0,1-.568,1.223,2.562,2.562,0,0,1-1.676.473h-2.4v-4.825H318.17Z",
    transform: "translate(-309.963 -367.568)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M332.976,408.414a1.277,1.277,0,0,0-1.1.537,2.512,2.512,0,0,0-.392,1.5,2.9,2.9,0,0,0,.395,1.7,1.243,1.243,0,0,0,1.055.539,1.338,1.338,0,0,0,1.074-.5,2.494,2.494,0,0,0,.418-1.609,2.947,2.947,0,0,0-.362-1.625,1.228,1.228,0,0,0-1.093-.542m-4.573-.682h.959v2.346h1.162a2.967,2.967,0,0,1,.76-1.839,2.215,2.215,0,0,1,1.639-.634,2.342,2.342,0,0,1,1.354.344,2.649,2.649,0,0,1,.818.946,3.455,3.455,0,0,1,.323,1.623,3.224,3.224,0,0,1-.666,2.2,2.292,2.292,0,0,1-1.807.751,2.195,2.195,0,0,1-1.7-.7,3.035,3.035,0,0,1-.72-1.913h-1.162v2.484H328.4Z",
    transform: "translate(-312.203 -367.531)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M340.833,410.808v-.745a5.643,5.643,0,0,0,.829-.047.782.782,0,0,0,.418-.254.742.742,0,0,0,.2-.528.785.785,0,0,0-.259-.616.969.969,0,0,0-.669-.23,1.176,1.176,0,0,0-1.135.946l-.912-.148a1.942,1.942,0,0,1,2.057-1.58,1.972,1.972,0,0,1,1.42.492,1.568,1.568,0,0,1,.515,1.173,1.234,1.234,0,0,1-.672,1.094,1.6,1.6,0,0,1,.64.579,1.575,1.575,0,0,1,.213.832,1.53,1.53,0,0,1-.555,1.226,2.325,2.325,0,0,1-1.551.47,1.986,1.986,0,0,1-2.243-1.706l.9-.19a1.421,1.421,0,0,0,.5.835,1.354,1.354,0,0,0,.861.3,1.21,1.21,0,0,0,.808-.272.921.921,0,0,0-.312-1.569,3.734,3.734,0,0,0-.831-.061c-.032,0-.105,0-.219.005",
    transform: "translate(-314.55 -367.531)",
    fill: "#0063b0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M346.959,407.769h.959V410.1h2.659v-2.336h.959v5.612h-.959v-2.489h-2.659v2.489h-.959Z",
    transform: "translate(-313.303 -367.567)",
    fill: "#0063b0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M355.507,407.769h.959v4.281l2.66-4.281h1.033v5.612H359.2v-4.254l-2.659,4.254h-1.034Z",
    transform: "translate(-315.174 -367.567)",
    fill: "#0063b0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(47.079 40.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M364.143,407.769h.959v2.426a.924.924,0,0,0,.642-.175,3.77,3.77,0,0,0,.541-1.014,4.043,4.043,0,0,1,.458-.878.87.87,0,0,1,.405-.285,2.6,2.6,0,0,1,.735-.074h.192v.788l-.266-.005a.712.712,0,0,0-.485.111,2.77,2.77,0,0,0-.341.692,2.881,2.881,0,0,1-.4.761,1.615,1.615,0,0,1-.56.386,2.313,2.313,0,0,1,1.215,1.142l1.05,1.739h-1.055l-1.023-1.739a2.354,2.354,0,0,0-.549-.689.938.938,0,0,0-.559-.167v2.595h-.959Z",
    transform: "translate(-364.143 -407.769)",
    fill: "#0063b0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M375.829,407.769h.959V410.1h2.659v-2.336h.959v5.612h-.959v-2.489h-2.659v2.489h-.959Z",
    transform: "translate(-319.621 -367.567)",
    fill: "#0063b0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(62.559 40.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M387.9,410.527a7.076,7.076,0,0,1-1.567.359,3.653,3.653,0,0,0-.837.191.828.828,0,0,0-.379.309.836.836,0,0,0,.158,1.086,1.256,1.256,0,0,0,.85.253,1.992,1.992,0,0,0,.986-.24,1.487,1.487,0,0,0,.634-.658,2.275,2.275,0,0,0,.155-.951Zm.08,2.125a3.613,3.613,0,0,1-1.026.634,3.009,3.009,0,0,1-1.058.184,2.069,2.069,0,0,1-1.433-.452,1.485,1.485,0,0,1-.5-1.155,1.527,1.527,0,0,1,.189-.753,1.552,1.552,0,0,1,.5-.547,2.365,2.365,0,0,1,.69-.312,7,7,0,0,1,.853-.143,8.818,8.818,0,0,0,1.711-.328c0-.13.005-.213.005-.249a1.042,1.042,0,0,0-.273-.819,1.615,1.615,0,0,0-1.092-.322,1.707,1.707,0,0,0-1,.235,1.434,1.434,0,0,0-.477.833l-.938-.127a2.3,2.3,0,0,1,.421-.964,1.85,1.85,0,0,1,.848-.565,3.82,3.82,0,0,1,1.284-.2,3.414,3.414,0,0,1,1.178.17,1.545,1.545,0,0,1,.666.425,1.49,1.49,0,0,1,.3.647,5.326,5.326,0,0,1,.048.878v1.269a13.343,13.343,0,0,0,.062,1.677,2.1,2.1,0,0,0,.242.674h-1a1.98,1.98,0,0,1-.192-.692",
    transform: "translate(-383.96 -407.605)",
    fill: "#0063b0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M397.74,407.769h1.492l1.487,4.492,1.652-4.492h1.38v5.612h-.959v-4.519l-1.674,4.519h-.858l-1.583-4.735v4.735h-.938Z",
    transform: "translate(-324.416 -367.567)",
    fill: "#0063b0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(81.13 40.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M411.673,410.527a7.076,7.076,0,0,1-1.567.359,3.651,3.651,0,0,0-.837.191.828.828,0,0,0-.379.309.836.836,0,0,0,.158,1.086,1.257,1.257,0,0,0,.85.253,1.99,1.99,0,0,0,.986-.24,1.487,1.487,0,0,0,.634-.658,2.275,2.275,0,0,0,.155-.951Zm.08,2.125a3.594,3.594,0,0,1-1.026.634,3.005,3.005,0,0,1-1.058.184,2.07,2.07,0,0,1-1.433-.452,1.487,1.487,0,0,1-.5-1.155,1.527,1.527,0,0,1,.189-.753,1.556,1.556,0,0,1,.5-.547,2.38,2.38,0,0,1,.691-.312,7.005,7.005,0,0,1,.852-.143,8.815,8.815,0,0,0,1.711-.328q0-.2,0-.249a1.045,1.045,0,0,0-.272-.819,1.615,1.615,0,0,0-1.092-.322,1.707,1.707,0,0,0-1,.235,1.434,1.434,0,0,0-.477.833l-.937-.127a2.294,2.294,0,0,1,.42-.964,1.85,1.85,0,0,1,.848-.565,3.82,3.82,0,0,1,1.284-.2,3.414,3.414,0,0,1,1.178.17,1.545,1.545,0,0,1,.666.425,1.489,1.489,0,0,1,.3.647,5.323,5.323,0,0,1,.048.878v1.269a13.34,13.34,0,0,0,.062,1.677,2.087,2.087,0,0,0,.242.674h-1a1.981,1.981,0,0,1-.192-.692",
    transform: "translate(-407.734 -407.605)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M417.063,407.769h4.456v5.612h-.955v-4.825h-2.542v2.8a8.009,8.009,0,0,1-.064,1.29.935.935,0,0,1-.352.544,1.3,1.3,0,0,1-.831.232q-.336,0-.773-.042v-.793h.421a1.08,1.08,0,0,0,.427-.06.308.308,0,0,0,.17-.193,4.492,4.492,0,0,0,.043-.861Z",
    transform: "translate(-409.543 -407.642)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M425.744,407.769h.959v2.426a.924.924,0,0,0,.642-.175,3.77,3.77,0,0,0,.541-1.014,4.043,4.043,0,0,1,.459-.878.87.87,0,0,1,.405-.285,2.6,2.6,0,0,1,.735-.074h.192v.788l-.266-.005a.712.712,0,0,0-.485.111,2.753,2.753,0,0,0-.341.692,2.925,2.925,0,0,1-.4.761,1.62,1.62,0,0,1-.559.386,2.314,2.314,0,0,1,1.215,1.142l1.05,1.739h-1.055l-1.023-1.739a2.365,2.365,0,0,0-.549-.689.937.937,0,0,0-.559-.167v2.595h-.959Z",
    transform: "translate(-411.676 -407.642)",
    fill: "#0063b0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M432.7,407.769h.959v4.281l2.659-4.281h1.034v5.612H436.4v-4.254l-2.66,4.254H432.7Z",
    transform: "translate(-332.068 -367.567)",
    fill: "#0063b0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(106.832 37.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M444.691,408.557h-1.364a1.592,1.592,0,0,0-1.106.264.878.878,0,0,0-.248.618.813.813,0,0,0,.366.737,2.538,2.538,0,0,0,1.292.235h1.06Zm.955-.788v5.612h-.955v-2.188h-.554a1.7,1.7,0,0,0-.754.129,2.794,2.794,0,0,0-.723.833l-.837,1.226h-1.188l1.033-1.511a1.648,1.648,0,0,1,.944-.782,1.837,1.837,0,0,1-1.218-.587,1.656,1.656,0,0,1-.4-1.094,1.5,1.5,0,0,1,.519-1.183,2.222,2.222,0,0,1,1.505-.455Z",
    transform: "translate(-440.636 -405.449)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M458.5,409.879a2.338,2.338,0,0,0-.419-1.438,1.387,1.387,0,0,0-1.18-.56,1.423,1.423,0,0,0-1.226.592,2.615,2.615,0,0,0-.433,1.58,2.133,2.133,0,0,0,.477,1.495,1.533,1.533,0,0,0,1.175.518,1.379,1.379,0,0,0,1.159-.6,2.6,2.6,0,0,0,.445-1.588m.048-5.105.847.01a1.446,1.446,0,0,1-.253.788.882.882,0,0,1-.5.285,7.2,7.2,0,0,1-1.2.063,3.9,3.9,0,0,0-1.62.228,1.307,1.307,0,0,0-.621.727,4.022,4.022,0,0,0-.21,1.287,2.471,2.471,0,0,1,.848-.8,2.231,2.231,0,0,1,1.092-.266,2.449,2.449,0,0,1,1.844.758,2.833,2.833,0,0,1,.731,2.053,3.164,3.164,0,0,1-.368,1.612,2.951,2.951,0,0,1-.872.973,2.915,2.915,0,0,1-2.939-.114,2.956,2.956,0,0,1-.858-1.17,7.16,7.16,0,0,1-.3-2.484,4.348,4.348,0,0,1,.758-3,3.153,3.153,0,0,1,2.337-.771,9.563,9.563,0,0,0,1.114-.032.219.219,0,0,0,.171-.148",
    transform: "translate(-443.598 -404.774)",
    fill: "#0063b0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M463.312,407.769h.959v4.281l2.659-4.281h1.034v5.612h-.959v-4.254l-2.66,4.254h-1.033Z",
    transform: "translate(-338.767 -367.567)",
    fill: "#0063b0"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(130.843 40.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M473.08,410.808v-.745a5.643,5.643,0,0,0,.829-.047.782.782,0,0,0,.418-.254.742.742,0,0,0,.2-.528.785.785,0,0,0-.259-.616.97.97,0,0,0-.669-.23,1.176,1.176,0,0,0-1.134.946l-.912-.148a1.942,1.942,0,0,1,2.057-1.58,1.969,1.969,0,0,1,1.42.492,1.568,1.568,0,0,1,.515,1.173,1.234,1.234,0,0,1-.672,1.094,1.6,1.6,0,0,1,.64.579,1.575,1.575,0,0,1,.213.832,1.531,1.531,0,0,1-.555,1.226,2.325,2.325,0,0,1-1.551.47,1.987,1.987,0,0,1-2.244-1.706l.9-.19a1.418,1.418,0,0,0,.5.835,1.349,1.349,0,0,0,.861.3,1.209,1.209,0,0,0,.807-.272.921.921,0,0,0-.312-1.569,3.738,3.738,0,0,0-.832-.061c-.031,0-.1,0-.218.005",
    transform: "translate(-471.374 -407.605)",
    fill: "#0063b0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M479.206,407.769h.959V410.1h2.66v-2.336h.959v5.612h-.959v-2.489h-2.66v2.489h-.959Z",
    transform: "translate(-342.245 -367.567)",
    fill: "#0063b0"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(143.319 40.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M488.389,410h3.161a1.9,1.9,0,0,0-.362-1.062,1.477,1.477,0,0,0-1.189-.549,1.528,1.528,0,0,0-1.111.438,1.728,1.728,0,0,0-.5,1.173m3.15,1.538.991.122a2.4,2.4,0,0,1-.869,1.337,2.629,2.629,0,0,1-1.62.476,2.6,2.6,0,0,1-1.969-.758,2.947,2.947,0,0,1-.727-2.127,3.086,3.086,0,0,1,.735-2.2,2.5,2.5,0,0,1,1.908-.782,2.43,2.43,0,0,1,1.854.766,3.029,3.029,0,0,1,.719,2.156c0,.056,0,.141-.005.253h-4.221a2.145,2.145,0,0,0,.527,1.417,1.577,1.577,0,0,0,1.183.491,1.475,1.475,0,0,0,.9-.275,1.821,1.821,0,0,0,.591-.877",
    transform: "translate(-487.345 -407.605)",
    fill: "#0063b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M499.974,411.289l.944.122a2.419,2.419,0,0,1-.791,1.513,2.318,2.318,0,0,1-1.565.547,2.44,2.44,0,0,1-1.868-.753,3.038,3.038,0,0,1-.706-2.159,3.867,3.867,0,0,1,.3-1.59,2.11,2.11,0,0,1,.924-1.023,2.765,2.765,0,0,1,1.351-.341,2.363,2.363,0,0,1,1.508.462,2.12,2.12,0,0,1,.751,1.314l-.933.143a1.532,1.532,0,0,0-.472-.85,1.226,1.226,0,0,0-.818-.286,1.5,1.5,0,0,0-1.178.515,2.43,2.43,0,0,0-.453,1.63,2.513,2.513,0,0,0,.437,1.644,1.428,1.428,0,0,0,1.141.513,1.351,1.351,0,0,0,.944-.344,1.7,1.7,0,0,0,.48-1.057",
    transform: "translate(-489.237 -407.605)",
    fill: "#0063b0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintrade);
export default __webpack_public_path__ + "static/media/fintrade.3d28e751020cc9d8173d4cdefb2fa9e2.svg";
export { ForwardRef as ReactComponent };